import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/Common/HeroSection';
import BannerSection from '../components/Common/PlatformBannerSection';
import HealthCareExperience from '../components/DigitalHealthPlatform/HealthCareExperience';
import StakeholdersSection from '../components/DigitalHealthPlatform/StakeHolderSection';
import SolutionsCareJourney from '../components/DigitalHealthPlatform/SolutionsCare';

const DigitalHealthPlatform = () => {
  const navigate = useNavigate();
  
  const handleScheduleDemo = () => {
    navigate('/get-in-touch?purpose=Product Demo');
  };

  const heroButtons = [
    {
      label: 'Book a Demo',
      className: 'btn-secondary',
      onClick: handleScheduleDemo
    },
    {
      label: 'Talk to Our Experts',
      className: 'btn-outline',
      onClick: () => console.log('Talk to our experts clicked')
    },
  ];

  const stakeholders = [
    {
      image: '/assets/digitalHealthPlatform/4section-1.svg',
      title: 'Patients',
      features: [
        'Easy access to healthcare services',
        'Personalized and continuous care experiences'
      ]
    },
    {
      image: '/assets/digitalHealthPlatform/4section-2.svg',
      title: 'Providers',
      features: [
        'Unified view of patient information',
        'Streamlined workflows and clinical insights'
      ]
    },
    {
      image: '/assets/digitalHealthPlatform/4section-3.svg',
      title: 'Enterprise',
      features: [
        'Scalable healthcare solutions',
        'Data-driven decision making'
      ]
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <HeroSection
        backgroundImage='/assets/digitalHealthPlatform/hero.svg'
        title="Powering the Future of Digital Healthcare"
        subtitle="A unified digital ecosystem powering multiple healthcare solutions—designed to deliver connected, personalized, and scalable care experiences."
        buttons={heroButtons}
        textAlign="center"
        height="h-screen"
        titleSize="text-5xl"
      />
    
    <HealthCareExperience />
    <div className="h-8 md:h-12 lg:h-16 bg-white"></div>

    <SolutionsCareJourney />

    <StakeholdersSection stakeholders={stakeholders} />

    <BannerSection
        title="Get Started with"
        highlightedText="Avexa"
        description="Discover how Avexa’s Digital Health Platform can power connected, patient-centric healthcare solutions across multiple care domains."
        buttonText="Book a Demo"
        buttonLink="/get-in-touch?purpose=Product Demo"
        backgroundColor="var(--primary-color)"
        variant="dark"
      />
      <div className="h-8 md:h-12 lg:h-16 bg-white"></div>

    </div>
  );
};

export default DigitalHealthPlatform;